import { Component, OnInit } from '@angular/core';
import { AslibModalComponent, IAslibModalOptions } from '@aslib/modal';
import { AslibGridComponent } from '@aslib/components';
import { BaseComponentService } from '../../services/base-component.service';
import { Subject } from 'rxjs/Subject';


@Component({
  selector: 'gpa-grupo',
  templateUrl: './grupo.component.html',
  providers: [BaseComponentService]
})

export class GrupoComponent extends BaseComponentService implements OnInit {
  protected aslibModal: AslibModalComponent;

  ngOnInit() {

    this.preencheGrid();

    GrupoComponent.updateList.subscribe(data => {
      this.preencheGrid();
      this.fecharModal();
      this.ngOnInit();
    });


  }

  preencheGrid() {
    this.lista = [];
    const rota = '/api/ControleAcessoPagamentoAutomatico/';

    this._service.routePrefix = rota;
    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.lista = data;
    },
    (error) => {
        this.exibirErro(error);
        this.aslibLoadingService.complete();
      },
    () => {
        this.aslibLoadingService.complete();
      }
    );

  }

  // Metodo para atualizar Lista
  public static updateList: Subject<any> = new Subject();

  limpar(grid: AslibGridComponent){
    this.lista = [];
    grid.dataset = null;
  }

  excluirGrupo(modal: AslibModalComponent, item) {
    const options: IAslibModalOptions = {
      title: 'Exclusão de item',
      backdrop: 'static',
      text: `Tem certeza de que deseja excluir o registro?`,
      okText: 'Sim',
      cancelarText: 'Não',
      cancelarVisible: true
    };
    
    this.aslibModal.open(options).result.then(
      () => {
        options.title = 'Exclusão de Registro';
        options.okText = 'Fechar';
        options.cancelarVisible = false;

        this._service.routePrefix = 'api/ControleAcessoPagamentoAutomatico/';
        this.aslibLoadingService.start();

        this.subSave = this._service.delete(item.id, 'gpa').subscribe(data => {},
          erro => {
            this.exibirErro(erro);
            this.aslibLoadingService.complete();
          },
          () => {
            this.exibirSucesso('Registro excluído com sucesso');
            this.aslibLoadingService.complete();
            this.preencheGrid();
          }
        );
      },
      () => {
      }
    );
  }

  openModalGrupos(conteudo: any) {
    const options: IAslibModalOptions = {title: 'Incluir Grupo', 
    backdrop: 'static', cancelarVisible: false, size: 'lg', content: conteudo, okVisible: false};

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/controle-dados/grupo/grupo.component.ts